<app-module-header [title]="'Start'" [icon]="'dashboard'"></app-module-header>

@if (myConfigService?.myConfig?.organizations) {
<div class="organizations-container row">
  @for (organization of myConfigService?.myConfig?.organizations; track organization) {
  <div class="col-xs-12 col-md-6 col-lg-4 mb-3">
    <div class="organization-card">
      <div class="card-header">
        <h1 class="org-title">{{ organization.organizationName }}</h1>
        <!-- <span class="module-count">{{ organization.config?.modules?.length || 0 }} modules</span> -->
      </div>
      <div class="modules-grid">
        @for (module of organization.config?.modules; track module) {
        @if (myConfigService.hasModuleAccess(module.name, organization, this.authService.isAdminOrSiteAdmin())) {
        <div class="module-card" [routerLink]="[module.menu.url]">
          <div class="module-icon">
            <mat-icon>{{ module.menu.icon }}</mat-icon>
          </div>
          <h3 class="module-name">{{ module.menu.name }}</h3>
        </div>
        }
        }
      </div>
    </div>
  </div>
  }
</div>
}
@if (false) {
<div class="container-fluid my-4">
  @if (authService?.loggedIn()) {
  <mat-card appearance="outlined" class="text-container text-center mat-elevation-z8">
    <mat-card-header>
      <h2 class="welcome-text">
        {{'LOGIN.WELCOME' | transloco}}
      </h2>
    </mat-card-header>
    <mat-card-content>
      <div class="text-left">
        <b>Parkifly</b>
        <ul>
          <li><a href="/flygets/flygets-start" target="_blank">flygets.se</a> |
            <a href="/faq" target="_blank">faq</a> |
            <a href="/flygets/hitta-hit" target="_blank">/flygets/hitta-hit</a> |
            <a href="/flygets/kontakta-oss" target="_blank">/flygets/kontakta-oss</a> |
            <a href="/self-service" target="_blank">/self-service</a> |
            <a href="/kund" target="_blank" class="deprecated-link">/kund</a> |
            <a href="/Shuttlebuss/Shuttlebuss.Service/Ping/LprLog" target="_blank">/lprLog</a> |
            <a href="/checkout/payment/c67b4aa6-b9e1-494a-c6e7-08dd860f8821" target="_blank">/checkout/payment/...</a> |
            <a href="/nazar" target="_blank">Nasar</a> |
            <a href="/tui" target="_blank">TUI</a> |
            <a href="/parkifly/flygets" target="_blank">parkifly/flygets</a> |
            <a href="/parkifly/skavsta" target="_blank">parkifly/skavsta</a> |
            <a href="/parkifly/handle-booking" target="_blank">parkifly/handle-booking</a>
          </li>
        </ul><br>
        <b>Shuttles</b>
        <ul>
          <li>
            <a href="/booking-service/5BF79F25-27BF-4B5B-AF83-B4A0233DAB70" target="_blank">Apart</a> |
            <a href="/booking-service/5BF79F25-27BF-4B5B-AF83-B4A0233DAB70" target="_blank">Apart Direkt</a> |
            <a href="/booking-service/417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1" target="_blank">Scandic</a> |
            <a href="/booking-service/417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1" target="_blank">Scandic Direkt</a>
          </li>
        </ul><br>
        <b>Components to be released:</b>
        <ul>
          <li>
            <a href="/parkifly/tui" target="_blank">parkifly/tui</a> |
            <a href="/parkifly/nazar" target="_blank">parkifly/nazar</a>
          </li>
        </ul><br>
        <b>Components to be removed:</b>
        <ul>
          <li><a href="/parkifly/flygets" target="_blank" class="deprecated-link">parkifly/flygets</a> |
            <a href="/parkifly/skavsta" target="_blank" class="deprecated-link">parkifly/skavsta</a>
            |
            <a href="/parkifly/handle-booking" target="_blank" class="deprecated-link">parkifly/handle-booking</a>
          </li>
        </ul><br>
        <b>Displays Test:</b>
        <ul>
          <li>
            <a href="https://parking-display-test.mangocliff-b7a35cda.swedencentral.azurecontainerapps.io/?id=922CFD25-5617-40B5-8F1D-F635029975E9"
              target="_blank">Display Test p1 Gate 51</a> |
            <a href="https://parking-display-test.mangocliff-b7a35cda.swedencentral.azurecontainerapps.io/?id=3E487F75-4069-44E0-9211-6450FCFCFE9D"
              target="_blank">Display Test P3 Gate 91</a> |
            <a href="https://parking-display.blackmoss-70f082ae.swedencentral.azurecontainerapps.io/?id=922CFD25-5617-40B5-8F1D-F635029975E9"
              target="_blank">Display Prod P1 Gate 51</a> |
            <a href="https://parking-display.blackmoss-70f082ae.swedencentral.azurecontainerapps.io/?id=3E487F75-4069-44E0-9211-6450FCFCFE9D"
              target="_blank">Display Prod P3 Gate 91</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayEntry1"
              target="_blank">TestDisplayEntry1 P1</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayEntry2"
              target="_blank">TestDisplayEntry2 P1</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayExit1" target="_blank">TestDisplayExit1
              P1</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayRegister?gateId=6EE51A97-EF80-4EC3-8E3E-893AF0B9F83F"
              target="_blank">TestDisplayRegister P1</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayRegistered"
              target="_blank">TestDisplayRegistered P1</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayDriveUpRegistered"
              target="_blank">TestDisplayDriveUpRegistered P1</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayParkingFull"
              target="_blank">TestDisplayParkingFull P1</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayLicensePlateNotRead"
              target="_blank">TestDisplayLicensePlateNotRead P1</a> |
            <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayWrongParkingSite"
              target="_blank">TestDisplayWrongParkingSite P1</a> |
          </li>
        </ul><br>
      </div>
      <mat-action-list>
        @if (authService.isCompanyAdmin('Shuttlebuss') || authService.isSiteAdmin() ||
        authService.isDriver('Flygets.se') || authService.isStaff('Skavsta')) {
        <div mat-list-item routerLink="/dashboard" class="display-flex">
          <mat-icon class="mr-2">dashboard</mat-icon>{{'LOGIN.GO_TO_DASHBOARD' | transloco}}
        </div>
        }
      </mat-action-list>
    </mat-card-content>
  </mat-card>
  }
</div>
}